module.exports = __WEBPACK_EXTERNAL_MODULE_179__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/scheduler/queue"
// module id = 179
// module chunks = 0